import { Form } from 'antd';
import axios from 'axios';
import { navigate } from 'gatsby';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import isNil from 'utils/isNil';
import TextField from 'components/Form/TextField';
import Button from 'components/Button';
import RevealContent from 'components/RevealContent';
import { init, saveForm } from '../../../services/marketoService';
import { mapFormFieldValues } from 'utils/marketo';
import Text from 'components/Text';

const SubscribeForm = ({
  width,
  height,
  buttonTitle,
  buttonLinkTo,
  containerStyles,
  type,
  handleSubscribe,
  enableNotification,
  notificationMessage,
  notificationStyles,
  marketoFormId,
  revealProps,
  buttonType,
  ...otherProps
}) => {
  const [formErrors, setFormErrors] = useState({
    email: '',
  });

  const [values, setValues] = useState({
    email: '',
    utm_source: null,
    utm_medium: null,
    utm_campaign: null,
    utm_content: null,
    utm_term: null,
    utm_promo: null,
    clickId: '',
    order_id: '',
    gclid: '',
    creative: '',
    keyword: '',
    matchtype: '',
  });

  const [formValid, setFormValid] = useState({
    email: 0,
  });

  const [isUpdate, setUpdate] = useState(false);
  const [fieldHasValue, toggleFieldHasValue] = useState(false);
  const [active, setActive] = useState(true);

  useEffect(() => {
    init(marketoFormId);

    let url = window.location.search;
    let params = queryString.parse(url);
    const tempValues = { ...values };
    Object.keys(tempValues).map(key => {
      if (params[key]) {
        tempValues[key] = params[key];
        Cookies.set(key, params[key]);
      } else {
        const p = Cookies.get(key);
        if (p && p !== undefined) {
          tempValues[key] = p;
        }
      }
    });
    setValues(tempValues);
  }, []);

  function handleSubmit(e) {
    if (formValid['email'] != 1) {
      return;
    }

    if (handleSubscribe) {
      handleSubscribe(values.email);
    }

    if (enableNotification) {
      setActive(false);
      toggleFieldHasValue(false);
    }

    sendEmailMarketo();
    Bizible.Push('User', {
      eMail: values.email, // required
    });
    dataLayer.push({
      event: 'form submitted',
      form_type: 'Email Capture',
      ...mapFormFieldValues(values),
    });
  }

  const onHandleBlur = (id, newValue) => {
    checkFieldValidate(id, newValue);
  };

  const sendEmailMarketo = async () => {
    let response;

    try {
      response = await saveForm({
        ...values,
        marketoFormId,
      });
    } catch (e) {}

    Cookies.set('email', values.email);

    if (type === 'newsletter') {
      setValues({ email: '' });
    } else if (buttonLinkTo && !isNil(buttonLinkTo)) {
      if (buttonLinkTo.includes('https://')) {
        window.location.replace(buttonLinkTo);
      } else {
        navigate(buttonLinkTo);
      }
    }
  };

  async function checkFieldValidate(id, value) {
    let fieldValidation = formValid;
    let fieldValidationErrors = formErrors;

    fieldValidation[id] = 1;

    fieldValidation[id] = value.length >= 1 ? 1 : -1;
    fieldValidationErrors[id] = fieldValidation[id] === 1 ? '' : 'Looks like this field is blank';

    if (fieldValidation[id] === 1) {
      switch (id) {
        case 'email':
          fieldValidation[id] = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ? 1 : -1;
          break;
      }

      fieldValidationErrors[id] = fieldValidation[id] === 1 ? '' : 'Email is invalid';
    }

    setFormValid(fieldValidation);
    setFormErrors(fieldValidationErrors);
    setUpdate(!isUpdate);

    return fieldValidation[id];
  }

  const onHandleChange = (id, newValue) => {
    let tmpValues = Object.assign({}, values);

    tmpValues[id] = newValue;
    setValues(tmpValues);
    handleFieldChange(tmpValues);
  };

  const handleFieldChange = values => {
    const fieldValue = values['email'];

    fieldValue ? toggleFieldHasValue(true) : toggleFieldHasValue(false);
  };

  const handleFocus = () => {
    if (!active) {
      setActive(true);
    }
  };

  return (
    <MainContainer className={containerStyles}>
      <SubscribeFormContainer data-position="Email Capture Form" {...otherProps}>
        <Form.Item className="data-layer-form">
          <TextField
            id="email"
            type="text"
            nameType="Email"
            placeholderText={'Enter email address'}
            values={values}
            formValid={formValid}
            formErrors={formErrors}
            handleBlur={onHandleBlur}
            handleChange={onHandleChange}
            shadow={true}
            handleFocus={handleFocus}
          />
        </Form.Item>
        <Form.Item data-position="Form - Submit CTA">
          <Button
            shadow={true}
            type={buttonType}
            disabled={!active}
            onClick={handleSubmit}
            width="100%"
          >
            {buttonTitle}
          </Button>
        </Form.Item>
      </SubscribeFormContainer>

      {!active && (
        <Text
          type="p"
          size="normal"
          className={notificationStyles ? notificationStyles : 'section-hero--notification'}
          color="#00bb22"
        >
          {notificationMessage}
        </Text>
      )}
      {revealProps && (
        <RevealContent
          showContent={fieldHasValue}
          content={revealProps.content}
          styles={revealProps.styles}
        />
      )}
    </MainContainer>
  );
};

SubscribeForm.propTypes = {
  type: PropTypes.string,
};
SubscribeForm.defaultProps = {
  type: 'getDemo',
  handleSubscribe: null,
  enableNotification: false,
  notificationMessage: 'Thanks for subscribing!',
  buttonType: 'primary',
  marketoFormId: 2147,
};

export const STSubscribeForm = SubscribeForm;
export default STSubscribeForm;

const MainContainer = styled.div`
  .section-hero--notification {
    text-align: center;
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    color: var(--green-5);
    max-width: 370px;
    margin: 1em auto 0;
  }
`;

const SubscribeFormContainer = styled(Form)`
  display: flex;

  .ant-row.ant-form-item:first-child {
    width: 100%;
    max-width: 314px;
  }

  .text-field-wrapper {
    .text-field-input {
      height: 62px !important;
      box-shadow: 0 3px 6px 1px rgba(160, 161, 188, 0.35);
    }
  }

  button {
    font-weight: bold;
    padding: 15px 24px;
    min-width: 184px;
    margin-left: 16px;
    box-shadow: 0 3px 6px 1px rgba(160, 161, 188, 0.35);

    &:hover {
      box-shadow: none;
    }

    &:disabled {
      background-color: var(--disabled-color) !important;
      color: var(--disabled-text-color);
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;

    .ant-row.ant-form-item {
      width: 100%;
      margin-bottom: 12px;

      &:first-child {
        max-width: 100%;
      }
    }

    .text-field-wrapper .text-field-input {
      height: 55px !important;
    }

    button {
      font-size: 18px;
      line-height: 31px;
      padding: 12px 24px;
      width: 100%;
      margin-left: 0;
    }
  }
`;
